var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require('@/assets' + _vm.fileName),"alt":_vm.title}}),_c('p',{staticClass:"is-size-4 is-size-5-mobile",style:({ color: 'rgb(101, 227, 255)' })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }